import BrandsCenteredContent from 'components/BrandsCenteredContent';
import Skeleton from 'components/Skeleton';
import { Fragment } from 'react';
import useStyles from './styles';

const TextsSkeleton = () => {
  const classes = useStyles();

  const skeletonTextItem = (
    <div className={classes.skeletonTextItem}>
      <Skeleton height={12} />
    </div>
  );

  const skeletonTexts = Array.from({ length: 5 }, (_, index) => {
    const isEven = index % 2 === 0;
    const showDivider = isEven && index !== 0;

    return (
      <Fragment key={`textGroup_${index}`}>
        <div className={classes.itemWrapper}>
          {[0, 1].map(textIndex => (
            <Fragment key={`text_${textIndex}`}>{skeletonTextItem}</Fragment>
          ))}
        </div>

        {showDivider && <i className={classes.divider} />}
      </Fragment>
    );
  });

  return (
    <BrandsCenteredContent>
      <div className={classes.skeletonRoot}>
        <Skeleton height={40} />
        <div className={classes.skeletonTextsWrapper}>{skeletonTexts}</div>
        <Skeleton height={100} />
      </div>
    </BrandsCenteredContent>
  );
};

export default TextsSkeleton;
